module.exports = __webpack_public_path__ + "img/other-card.d9466230.png";